module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon2.45649dde.svg";